"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PRODUCT_SIZE_CHIP_INNER_PADDING = exports.MAX_NUMBER_OF_ARTICLES_IN_LISTER_PAGE_DEFAULT = exports.PRODUCT_FREDHOPPER_SEARCH_PARAM_PLATFORM = exports.PRODUCT_URL_PREFIX = void 0;
exports.PRODUCT_URL_PREFIX = 'p';
exports.PRODUCT_FREDHOPPER_SEARCH_PARAM_PLATFORM = 'public_site';
exports.MAX_NUMBER_OF_ARTICLES_IN_LISTER_PAGE_DEFAULT = 48;
exports.PRODUCT_SIZE_CHIP_INNER_PADDING = 16;
